var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#DarkGlobe--DWxyC';
                    var viewUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#view-DarkGlobe--DWxyC';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };